export default __webpack_public_path__ + "static/project-slide-7-2016-765-e27574d44fb72d92e99db761cb1de758.webp";